module.exports = __webpack_public_path__ + "static/media/metal.6dd78813.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phaser-assets/textures/metal.png
// module id = 2736
// module chunks = 0